import { module } from 'angular';
import { EcomStateDirective } from './directives/ecom-state';
import { PriceDisplayStateDirective } from './directives/price-display-state';
export var ngModule = module('gn.audio.cg.foundation.pricing', [])
    .directive('ecomState', EcomStateDirective)
    .directive('priceDisplayState', PriceDisplayStateDirective);
